import React from 'react';
import styles from './DENTWrapper.module.scss';
import DENTOverview from '../Overview/DENTOverview';
import DENTToothDetailModal from '../DENTToothDetailModal/DENTToothDetailModal';
import DENTQuickAdjustmentModal from '../DENTToothQuickAdjustmentModal/DENTToothQuickAdjustmentModal';
import { useDENTContext } from '../../Services/DENTContext';
import { OverviewMode } from '../../Enums/OverviewMode.enum';
import DENTToothQuickSelectOptions from '../DENTToothQuickSelectOptions/DENTToothQuickSelectOptions';
import useNotification from '../../../../Hooks/useNotification.hook';
import { Tooth } from '../../../../graphql/graphql';

const DENTWrapper: React.FC = () => {
	const {
		mouthData,
		activeTooth,
		setActiveTooth,
		setAdjustmentMode,
		overviewMode,
		toggleQuickSelectTeeth,
		quickSelectMode,
		adjustmentMode,
		activeMedicalExaminationId,
	} = useDENTContext();
	const { showNotificationAlert } = useNotification();

	const handleToothClick = (tooth: Tooth) => {
		if (!activeMedicalExaminationId) {
			return showNotificationAlert({
				content:
					'patientTreatment.meddiDENT.dentalCross.noActiveDentitionVisitAlert',
			});
		}

		if (quickSelectMode) {
			return toggleQuickSelectTeeth(tooth);
		}

		if (overviewMode && Object.values(OverviewMode).includes(overviewMode)) {
			setAdjustmentMode(true);
		}

		setActiveTooth(tooth);
	};

	const handleCloseDetailModal = () => {
		setActiveTooth(undefined);
	};

	if (!mouthData) {
		return <></>;
	}

	const isToothDetailModalOpen =
		activeTooth && overviewMode === OverviewMode.DEFAULT;

	return (
		<div className={styles.wrapper}>
			<DENTOverview data={mouthData} onToothClick={handleToothClick} />
			{adjustmentMode && <DENTQuickAdjustmentModal />}
			{isToothDetailModalOpen && (
				<DENTToothDetailModal onClose={handleCloseDetailModal} />
			)}
			{quickSelectMode && <DENTToothQuickSelectOptions />}
		</div>
	);
};

export default DENTWrapper;
